import { render, staticRenderFns } from "./AsideRestore.vue?vue&type=template&id=d766cbb8&scoped=true"
import script from "./AsideRestore.vue?vue&type=script&lang=js"
export * from "./AsideRestore.vue?vue&type=script&lang=js"
import style0 from "./AsideRestore.vue?vue&type=style&index=0&id=d766cbb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d766cbb8",
  null
  
)

export default component.exports